import {createContext, useContext} from 'react';
import {ICustomerAddress} from 'types';

type ITypeAddressCourierExpress = 'start' | 'end';

export interface IAddressContext {
  addresses?: ICustomerAddress[];
  selectedAddress?: ICustomerAddress;
  coordinatesAddress?: unknown;
  createNewAddress: (address: ICustomerAddress) => void;
  updateAddress: (address: ICustomerAddress) => void;
  setSelectedAddress: (address: ICustomerAddress) => void;
  openAddAddressModal: (addressId?: number | string) => void;
  isAddressesLoading: boolean;
  // courier-express
  selectedStartAddress?: ICustomerAddress;
  selectedEndAddress?: ICustomerAddress;
  onSetTypeAddressCourierExpressHelper?: (type: ITypeAddressCourierExpress) => void;
  mapAddressChanged?: boolean;
  setMapAddressChanged: (value: boolean) => void;
}

export const AddressContext = createContext<IAddressContext>({
  addresses: undefined,
  selectedAddress: undefined,
  coordinatesAddress: {},
  createNewAddress: () => {},
  updateAddress: () => {},
  setSelectedAddress: () => {},
  openAddAddressModal: () => {},
  isAddressesLoading: true,
  setMapAddressChanged: () => {},
});

export const useAddressContext = () => {
  const context = useContext(AddressContext);
  if (!context) throw new Error('useAddressContext must be used inside a `AddressProvider`');
  return context;
};

export type {ITypeAddressCourierExpress};
